/*
 * lumao-reviews.js
 * Zobrazí u recenzí (Judge.me) jen křestní jméno + iniciálu příjmení.
 * Např. "Miloš Kovář" -> "Miloš K." Platí na homepage carousel
 * i na widget recenzí na produktové stránce. Judge.me vykresluje
 * widgety klientsky a překresluje je (carousel rotuje), proto hlídáme
 * DOM přes MutationObserver a maskujeme i nově přidané/klonované karty.
 */
(function () {
  // Selektory na jméno recenzenta napříč Judge.me widgety.
  // .jm-reviewer-info__name = nový "revamp" widget (Vue) na produktové stránce.
  // .jdgm-rev__author atd. = starší widgety / carousel.
  var NAME_SELECTOR =
    '.jm-reviewer-info__name, .jdgm-rev__author, .jdgm-reviewer-name, .jdgm-rev__buyer-badge-wrapper .jdgm-rev__author';

  function maskName(text) {
    var t = (text || '').replace(/\s+/g, ' ').trim();
    if (!t) return null;
    var parts = t.split(' ');
    if (parts.length < 2) return null; // jen křestní jméno, není co maskovat
    var first = parts[0];
    var last = parts[parts.length - 1];
    var initial = last.charAt(0).toUpperCase();
    if (!initial) return null;
    return first + ' ' + initial + '.';
  }

  // maskName je idempotentní ("Miloš K." -> "Miloš K."), takže můžeme bez obav
  // přemaskovat i znovu. Nový Vue widget překresluje textové uzly a obnovil by
  // plné jméno — proto NEdržíme jednorázový dataset guard, ale maskujeme vždy.
  function maskEl(el) {
    if (!el) return;
    if (el.children.length === 0) {
      var masked = maskName(el.textContent);
      if (masked && masked !== el.textContent) el.textContent = masked;
    } else {
      el.childNodes.forEach(function (node) {
        if (node.nodeType === 3 && node.textContent.trim()) {
          var m = maskName(node.textContent);
          if (m && m !== node.textContent) node.textContent = m;
        }
      });
    }
  }

  function apply() {
    var nodes = document.querySelectorAll(NAME_SELECTOR);
    for (var i = 0; i < nodes.length; i++) maskEl(nodes[i]);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      apply();
    }, 60);
  }

  function init() {
    apply();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    // Pojistka, kdyby Judge.me dohydratoval později.
    [800, 2500, 5000].forEach(function (ms) {
      setTimeout(apply, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
